import { TableHead, TableCell, TableRow } from '@mui/material';
import { SharedContactsTableHeaderProps } from './Types/componentProps';

const SharedContactsTableHeader = (props: SharedContactsTableHeaderProps) => {
  const { columns } = props;

  return (
    <TableHead>
      <TableRow>
        {columns.map((col) => (
          <TableCell
            key={`shared-contacts-table-header-cell-${col}`}
            sx={{
              textAlign: 'center',
              color: 'white',
              fontSize: '16px',
              width: '8%',
              fontWeight: 700,
              backgroundColor: 'primary.main',
            }}
          >
            {col}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default SharedContactsTableHeader;
